import { createContext, useContext } from "react";

const LogoutLocalContext = createContext<() => void>(() => {});
const LogoutLocalProvider = LogoutLocalContext.Provider;
const useLogoutLocalContext = () => useContext(LogoutLocalContext);

export { LogoutLocalContext, LogoutLocalProvider, useLogoutLocalContext };
